import * as yup from "yup";

export const addPhoneNumberFormSchema = yup
  .object({
    phoneNumber: yup
      .string()
      .required("Телефонът е задължителен.")
      .min(11, "Моля, въведете пълния си телефонен номер с +359 отпред")
      .defined(),
  })
  .required();

export type IAddPhoneNumberFormModel = yup.InferType<
  typeof addPhoneNumberFormSchema
>;

export const addPhoneNumberFormDefaultValues: IAddPhoneNumberFormModel = {
  phoneNumber: "",
};
